module.exports = __webpack_public_path__ + "fa-solid-900.f093864079d44808c60d.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/assets/fonts/webfonts/fa-solid-900.woff2
// module id = ../../../../../src/assets/fonts/webfonts/fa-solid-900.woff2
// module chunks = styles